import { ITradeTag } from "@models";

// Transaction tags
export const TRANSACTION_TAG_MMF_BUY = "cashplus.mmf.buy";
export const TRANSACTION_TAG_MMF_REWARD = "cashplus.mmf.reward";
export const TRANSACTION_TAG_MMF_SELL = "cashplus.mmf.sell";

export function isEarnOnFiatTagComparisonHelper(tags: ITradeTag[] = []): boolean {
	if (tags?.length) {
		const shortNames = tags.map((t) => t.attributes.short_name);
		return (
			shortNames.includes(TRANSACTION_TAG_MMF_BUY) ||
			shortNames.includes(TRANSACTION_TAG_MMF_REWARD) ||
			shortNames.includes(TRANSACTION_TAG_MMF_SELL)
		);
	}

	return false;
}
